import { Resource } from '../../../../lib/types/aemDataModels';
import { MappedAEMProperties } from '../../../../types';
import { HeadingLevel } from '../../../../lib/utils/HeadingMapper';
import ResourceItem from '../../base/ResourceItem/ResourceItem';
import styles from './ResourceList.module.scss';
import PureHeading from '../../../common/Heading/PureHeading';
import Layout from '../../../common/Layout/Layout';

export type ResourceListProps = {
  resources?: Resource[];
  headingLevel: HeadingLevel;
  heading: string;
} & MappedAEMProperties;

const ResourceList = ({ resources, heading, headingLevel }: ResourceListProps) => (
  <Layout>
    {!!heading && (
      <PureHeading level={headingLevel} className={styles.heading}>
        {heading}
      </PureHeading>
    )}
    <ul className={styles.resourceList}>
      {resources?.map(item => (
        <li key={item.link}>
          <ResourceItem {...item} />
        </li>
      ))}
    </ul>
  </Layout>
);

export default ResourceList;
